import { useState } from "react";
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import {
  CustomTableFooter,
  StyledTableCell,
  StyledTableRow,
} from "../../../components";
import { BlockRoundedICON, OptionICON } from "../../../assets/icons";

const style = {
  fontSize: 14,
  color: theme.colors.black,
  fontWeight: 550,
};

interface Props {
  data: any;
  onBlock?: (item: any) => void;
}

function CorbeilleTable({ data, onBlock }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ mb: 2, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)" }}
    >
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ bgcolor: "#fff" }}>
            <TableCell sx={style}>
              <Typography>{capitalizeFirstLetter(i18n.t("taches"))}</Typography>
            </TableCell>
            <TableCell sx={style}>
              <Typography>
                {capitalizeFirstLetter(i18n.t("createur"))}
              </Typography>
            </TableCell>
            <TableCell sx={style}>
              <Typography>{capitalizeFirstLetter(i18n.t("statut"))}</Typography>
            </TableCell>
            <TableCell sx={style}>
              <Typography>
                {capitalizeFirstLetter(i18n.t("responsable"))}
              </Typography>
            </TableCell>
            <TableCell sx={style}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data
          ).map((item: any, index: any) => (
            <StyledTableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                cursor: "pointer",
              }}
            >
              <StyledTableCell>{item.libelle}</StyledTableCell>
              <StyledTableCell>{`${item.nomAdminUtilisateur || ""} ${
                item.prenomAdminUtilisateur || ""
              }`}</StyledTableCell>
              <StyledTableCell>{i18n.t(item.statutTache)}</StyledTableCell>
              <StyledTableCell>{`${item.infosOffre?.boss?.nom || ""} ${item.infosOffre?.boss?.prenom || ""}`}</StyledTableCell>
              <StyledTableCell
                style={{ justifyContent: "flex-end", display: "flex" }}
              >
                <Stack direction={"row"} spacing={1}>
                  <IconButton>
                    <BlockRoundedICON />
                  </IconButton>
                  <IconButton>
                    <OptionICON />
                  </IconButton>
                </Stack>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
        <CustomTableFooter
          rowsPerPage={rowsPerPage}
          data={data}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Table>
    </TableContainer>
  );
}

export default CorbeilleTable;
